"use client";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { authService } from "@/lib/services/auth";

export default function NotFound() {
  const router = useRouter();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is authenticated to show appropriate redirect button
    const authenticated = authService.isAuthenticated();
    setIsAuthenticated(authenticated);
  }, []);

  const handleGoBack = () => {
    if (isAuthenticated) {
      router.push('/dashboard/main');
    } else {
      router.push('/login');
    }
  };

  const handleGoHome = () => {
    router.push('/');
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-canvas-alt to-canvas-sunken px-4">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-[10rem] md:text-[12rem] font-bold text-inversePurple-100 leading-none tracking-tight">
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="mb-8 space-y-4">
          <h2 className="text-3xl md:text-4xl font-semibold text-ink">
            Page Not Found
          </h2>
          <p className="text-lg md:text-xl text-muted max-w-md mx-auto">
            Sorry, we couldn't find the page you're looking for. It might have been moved or deleted.
          </p>
        </div>

        {/* Helpful Information */}
        <div className="mb-10 p-6 bg-white rounded-2xl shadow-sm border border-line max-w-md mx-auto">
          <h3 className="text-sm font-semibold text-ink mb-3">
            What you can do:
          </h3>
          <ul className="text-sm text-muted space-y-2 text-left">
            <li className="flex items-start">
              <span className="text-inversePurple-100 mr-2">•</span>
              <span>Check the URL for typos</span>
            </li>
            <li className="flex items-start">
              <span className="text-inversePurple-100 mr-2">•</span>
              <span>Go back to the previous page</span>
            </li>
            <li className="flex items-start">
              <span className="text-inversePurple-100 mr-2">•</span>
              <span>Return to the {isAuthenticated ? 'dashboard' : 'home page'}</span>
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => router.back()}
            className="w-full sm:w-auto px-8 py-4 text-base font-semibold text-ink bg-white border-2 border-line-strong rounded-xl hover:bg-canvas-alt hover:border-muted-soft active:scale-[0.98] transition-all duration-200 shadow-sm"
          >
            ← Go Back
          </button>
          
          <button
            onClick={handleGoBack}
            className="w-full sm:w-auto px-8 py-4 text-base font-semibold text-white bg-inversePurple-300 rounded-xl hover:bg-inversePurple-100 active:scale-[0.98] transition-all duration-200 shadow-md"
          >
            {isAuthenticated ? '🏠 Go to Dashboard' : '🏠 Go to Home'}
          </button>
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-sm text-muted">
          Need help? Contact support at{" "}
          <a 
            href="mailto:support@inversepay.app" 
            className="text-inversePurple-100 hover:text-inversePurple-300 font-medium underline"
          >
            support@inversepay.app
          </a>
        </div>
      </div>
    </div>
  );
}
